import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { getDefaultAuthenticatedRoute, hasNetworkMembership } from "../../utils/authRoles";

const NetworkRouteGuard = ({ children }) => {
  const { networkId } = useParams();
  const { user, isLoading } = useUser();

  if (isLoading) return null;
  if (hasNetworkMembership(user, networkId)) return children;

  return <Navigate to={getDefaultAuthenticatedRoute(user)} replace />;
};

export default NetworkRouteGuard;
